// A comma that is a thousands separator: followed by exactly three digits, then no digit.
const THOUSANDS_PART = /^\d{3}(?!\d)/;
// One currency symbol at the front, before or after the minus sign.
const LEADING_SYMBOL = /^(-?)[$€£¥](-?)/;

/**
 * A starting balance as a statement prints it, made into the server's form.
 *
 * Removes every space; removes one leading currency symbol, keeping the minus
 * sign on either side of it ("-$5.00" and "$-5.00" are both "-5.00"); removes
 * the commas only when every comma is a thousands separator (followed by
 * exactly three digits), so a decimal comma ("12,50") is left as typed.
 * Nothing else is changed: a figure still unreadable ("1.2.3", "12a") is sent
 * as typed and the server's refusal sentence is shown as it is.
 */
export function plainFigure(typed: string): string {
  const unspaced = typed.replace(/\s/g, "");
  const signed = unspaced.replace(LEADING_SYMBOL, (_, before: string, after: string) =>
    before || after ? "-" : "",
  );
  const parts = signed.split(",");
  const separators = parts.slice(1).every((part) => THOUSANDS_PART.test(part));
  return parts.length > 1 && separators ? parts.join("") : signed;
}
